import BaseService from './baseService';

class LocationService {   
    static getCountries() {
        return BaseService.getAndReturn(`/Locations/Countries`, BaseService.returnAssignedArray, 'Unable to fetch countries', false);
    }

    static searchLocation(countryCode, displayRegion2, displayCountry, cityName) {
        const url = `/Locations?countryCode=${countryCode}&displayRegion2=${displayRegion2}&displayCountry=${displayCountry}&cityName=${cityName}`;
        return BaseService.getAndReturn(url, BaseService.returnAssignedArray, 'Unable to search locations', false);
    }
}
export default LocationService;